const jwt = require('jsonwebtoken');
import { v4 as uuidv4 } from "uuid";
export const generateToken = () => {
    const payload = { randomPayload: new Date().getMilliseconds() +  uuidv4() };

    const secretKey = 'btt';

  return jwt.sign(payload, secretKey, { expiresIn: '5s' });
}